/*!
 * Developed by : Igor Ivanovic
 * User: igor
 * Date: 3/21/13
 * Time: 5:09 PM
 * @copyright : Nivas ltd.
 * www.nivas.hr
 * Jquery plugin extender
 */
(function(d){d.extendable=function(h){return function(a){var e=h.toString(),c="string"===typeof a,f=Array.prototype.slice.call(arguments,1),g=this;a=!c&&f.length?d.extend.apply(null,[!0,a].concat(f)):a;if(c&&"_"===a.charAt(0))return g;c?this.each(function(){var b=d.data(this,e),c=b&&d.isFunction(b[a])?b[a].apply(b,f):b;if(c!==b&&void 0!==c)return g=c,!1}):this.each(function(){var b=d.data(this,e);b?b.option(a||{}):d.data(this,e,new h(a,this))});return g}}})(jQuery);
